import React from 'react';

import { ConversationStatus } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import alertWarningTokens from '@amzn/meridian-tokens/base/icon/alert';
import lockTokens from '@amzn/meridian-tokens/base/icon/lock';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import { AIChatInput } from 'src/components/AI/AIChatInput';

interface IAILandingPage {
    conversationStatus: ConversationStatus;
    handleSendMessage: (message: string) => Promise<void>;
    isSending: boolean;
    isDisabled: boolean;
}

export const AILandingPage: React.FC<IAILandingPage> = (props) => {
    const { conversationStatus, handleSendMessage, isSending, isDisabled } = props;

    return (
        <Column width="100%" height="100%" heights={['fill', 'fit']}>
            {/* Main Content Area */}
            <Column alignmentVertical="center" alignmentHorizontal="center" heights={['fill', 'fit']}>
                <Column alignmentVertical="center" alignmentHorizontal="center" width="100%">
                    <Heading level={2}>Welcome to AI Chat</Heading>
                    <Text color="secondary">Ask anything about music royalties, deal terms, and more</Text>

                    <Row width="60%" alignmentHorizontal="center" widths={['fill']}>
                        <AIChatInput
                            conversationStatus={conversationStatus}
                            handleSendMessage={handleSendMessage}
                            isSending={isSending}
                            isDisabled={isDisabled}
                        />
                    </Row>
                </Column>

                {/* Bottom Disclaimer Section */}
                <Column alignmentHorizontal="center" spacingInset="400">
                    <Box width="60%" spacingInset="300">
                        <Column spacing="300">
                            <Row alignmentVertical="top" spacing="200">
                                <Icon tokens={alertWarningTokens} />
                                <Text type="b200" color="secondary">
                                    Disclaimer: Our AI assistant uses generative AI to retrieve data and compose
                                    responses. Please verify important information with authoritative sources.
                                </Text>
                            </Row>

                            <Row alignmentVertical="top" spacing="200">
                                <Icon tokens={lockTokens} />
                                <Text type="b200" color="secondary">
                                    Privacy Notice: Your chat sessions with this agent are not private and are
                                    accessible by developers of the tool. Please do not send private or sensitive
                                    information to the Paper AI Agent.
                                </Text>
                            </Row>
                        </Column>
                    </Box>
                </Column>
            </Column>
        </Column>
    );
};
